import { h, Fragment } from "preact";
import { Edit } from "../../helpers/icons";
import StockStatus from "../stock-status/stock-status";
import ProductSetItemFormDrawer from "./product-set-item-form-drawer";
import setItemLayouts from "./setItemLayouts";
import ProductSetItemFormInline from "./product-set-item-form-inline";

export default function ProductSetItem({
  product,
  item,
  inStock,
  itemId,
  formStyle = setItemLayouts.drawer,
  idPrefix,
  enableAvailabilityPreview,
  updateItem,
}) {
  console.log(`formStyle`, formStyle);
  if (!product) return null;

  const { variant, quantity } = item;
  const variantUrl = `${product.helpers.url}?variant=${variant.id.replace("gid://shopify/ProductVariant/", "")}`;

  return (
    <div
      className={`product-set-item ${inStock ? "" : "product-set-item--out-of-stock"}`}
    >
      {variant.image ? (
        <img
          className={`product-set-item__image ${inStock ? "" : "product-set-item__image--out-of-stock"}`}
          src={window.getSizedImageUrl(variant.image.url, "x160")}
          alt=""
        />
      ) : (
        <div className="product-set-item__image product-set-item__image--placeholder"></div>
      )}
      {formStyle === setItemLayouts.drawer && (
        <ProductSetItemFormDrawer
          product={product}
          item={item}
          itemId={itemId}
        />
      )}
      {formStyle === setItemLayouts.inline && (
        <ProductSetItemFormInline
          product={product}
          item={item}
          itemId={itemId}
          idPrefix={idPrefix}
          enableAvailabilityPreview={enableAvailabilityPreview}
          updateItem={updateItem}
        />
      )}
    </div>
  );
}
